import { AccordionModule } from 'primeng/accordion';
import { AnimateOnScroll } from 'primeng/animateonscroll';
import { AutoFocus } from 'primeng/autofocus';
import { Avatar } from 'primeng/avatar';
import { AvatarGroup } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BlockUI } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { Card } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { Chip } from 'primeng/chip';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DatePicker } from 'primeng/datepicker';
import { Dialog } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { FileUpload } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { IconField } from 'primeng/iconfield';
import { Image } from 'primeng/image';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIcon } from 'primeng/inputicon';
import { InputMask } from 'primeng/inputmask';
import { InputNumber } from 'primeng/inputnumber';
import { InputText, InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { Menu } from 'primeng/menu';
import { Menubar } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { Panel } from 'primeng/panel';
import { PanelMenu } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { Popover } from 'primeng/popover';
import { ProgressBar } from 'primeng/progressbar';
import { ProgressSpinner } from 'primeng/progressspinner';
import { RadioButton } from 'primeng/radiobutton';
import { Rating } from 'primeng/rating';
import { Ripple } from 'primeng/ripple';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Select } from 'primeng/select';
import { SelectButton } from 'primeng/selectbutton';
import { Skeleton } from 'primeng/skeleton';
import { StepperModule } from 'primeng/stepper';
import { StepsModule } from 'primeng/steps';
import { TabsModule } from 'primeng/tabs';
import { Tag } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { TieredMenu } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Tooltip } from 'primeng/tooltip';
import { ToolbarModule } from 'primeng/toolbar';

export const PRIMENG_MODULES = [
	AccordionModule,
	AnimateOnScroll,
	AutoFocus,
	Avatar,
	AvatarGroup,
	BadgeModule,
	BlockUI,
	ButtonModule,
	Card,
	CarouselModule,
	Chip,
	ConfirmDialog,
	ConfirmPopupModule,
	DatePicker,
	Dialog,
	DividerModule,
	DrawerModule,
	FileUpload,
	GalleriaModule,
	IconField,
	Image,
	InputGroup,
	InputGroupAddonModule,
	InputIcon,
	InputMask,
	InputNumber,
	InputText,
	InputTextModule,
	KnobModule,
	Menu,
	Menubar,
	MessageModule,
	OverlayBadgeModule,
	Panel,
	PanelMenu,
	PasswordModule,
	Popover,
	ProgressBar,
	ProgressSpinner,
	RadioButton,
	Rating,
	Ripple,
	ScrollPanel,
	Select,
	SelectButton,
	Skeleton,
	StepperModule,
	StepsModule,
	TabsModule,
	Tag,
	TextareaModule,
	TieredMenu,
	ToastModule,
	ToggleSwitch,
	Tooltip,
	ToolbarModule,
];
